<template>
    <div>
    <v-dialog v-model="visualizar" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ cliente.razonSocial }}</span>
          <v-spacer></v-spacer>
         
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="cliente.razonSocial" label="Razon Social" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="cliente.giro" label="Giro" required outlined></v-text-field>
              </v-col>              
              <v-col cols="4">
                <v-text-field v-model="cliente.segmento" label="Segmento" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="cliente.rut" label="Rut" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="cliente.comuna" label="Comuna" required outlined></v-text-field>
              </v-col>              
              <v-col cols="4">
                <v-text-field v-model="cliente.region" label="Region" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="cliente.pais" label="Pais" required outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="cliente.telefono" label="Telefono" outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select :items="contactos" v-model="cliente.contacto" label="Contactos" outlined></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="cliente.direccion" label="Direccion" outlined></v-text-field>
              </v-col>
 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import api from "../conf/ruta-base"
import moment from "moment";
import axios from 'axios';
import swal from "sweetalert";
moment.locale('es');
export default {
    data() {
        return {
            cliente:{},
            clienteDefault: {},
            contactos:[]
        }
    },
  props: {
    editedItem: {
      type: Object,
      default: null
    },
    editedIndex: {
        type: Number,
        default: -1
    },
    visualizar: {
        type: Boolean,
        default: false,
    }
  },
  watch:{
    editedItem(data){
        if(data) this.cliente = data;
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
    close(){
        this.$emit('close',false)
    },
    presave(){
        if(!this.cliente.razonSocial || !this.cliente.giro || !this.cliente.segmento || !this.cliente.rut) {
            swal('','Los campos de identificacion son obligatorios','error'); return;
        }
        if(!this.cliente.comuna || !this.cliente.region || !this.cliente.pais) {
            swal('','Los campos de ubicacion son obligatorios','error'); return;
        }
        if(!this.cliente.direccion || !this.cliente.telefono || !this.cliente.contacto) {
            swal('','Los campos de contacto son obligatorios','error'); return;
        }
        if(this.editedIndex == -1){
            axios.post(`${api.api}clientes`,this.cliente).then(res=>{
                this.$emit('cargaClientes',res.data)
                this.$emit('close',false)
                swal('','Cliente guardado','success');
            }).catch(err=>{
                swal('','Error al guardar Cliente','error');
            })
        }else{
            axios.put(`${api.api}clientes/${this.cliente.id}`,this.cliente).then(res=>{
                this.$emit('cargaClientes',this.cliente)
                //this.$emit('close',false)
                swal('','Cliente actualizado','success');
            }).catch(err=>{
                swal('','Error al actualizar Cliente','error');
            })
        }
    },
  },
  mounted(){
    axios.get(`${api.api}contactos`).then(res=>{
        res.data.forEach(contacto => {
          this.contactos.push({text: `${contacto.nombre} - ${contacto.area}`, value: contacto.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de contactos','error');
    })
  }
}
</script>